import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from "@mui/material/Box";
import { TextFieldProps } from "@mui/material/TextField";
import theme from "../theme/theme";
import dayjs from "dayjs";
import { Typography } from "@mui/material";

type BrowserInputProps = TextFieldProps & {
  ownerState?: any;
};

interface Props {
  value?: any;
  label?: string;
  title?: string;
  onChange?: (ev: any) => void;
  rootStyle?: React.CSSProperties;
}

const BrowserInput = function BrowserInput(props: BrowserInputProps) {
  const { inputProps, InputProps, ownerState, inputRef, error, ...other } =
    props;

  return (
    <Box sx={{ display: "flex", alignItems: "center",  width: "100%", }} ref={InputProps?.ref}>
      <input
        style={{
          border: "none",
          textAlign: "left",
          width: "100%",
        }}
        ref={inputRef}
        {...inputProps}
        {...(other as any)}
      />
      {InputProps?.endAdornment}
    </Box>
  );
};

export default function CustomDateField({
  value,
  label,
  onChange,
  title,
  rootStyle
}:Props) {
  return (
  <Box sx={{width: '100%', marginTop: 3,...rootStyle,}}>
     {title ? (
        <Typography
          color="black"
          sx={{
            fontSize: {
              xs: 12,
              md: 14,
            },
            mb: 1,
          }}
        >
          {title}
        </Typography>
      ) : null}
      <DemoContainer
        components={["DatePicker"]}
        sx={{
          backgroundColor: theme.colors.white,
          p: 1,
          border: "1px solid #c2c2c2",
          borderRadius: 1,
          height: 50,
          width: "100%",
        }}
      >
        <DatePicker
          slots={{
            textField: BrowserInput,
          }}
          sx={{ width: "100%", backgroundColor: theme.colors.white }}
          className="datefield"
          label={label}
          value={dayjs(new Date(value))}
          onChange={onChange}
        />
      </DemoContainer>
  
  </Box>
  );
}
